"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var List_1 = __importDefault(require("@material-ui/core/List"));
var ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
var ListItemIcon_1 = __importDefault(require("@material-ui/core/ListItemIcon"));
var Collapse_1 = __importDefault(require("@material-ui/core/Collapse"));
var ExpandLess_1 = __importDefault(require("@material-ui/icons/ExpandLess"));
var ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
var core_1 = require("@material-ui/core");
var ArrowRight_1 = __importDefault(require("@material-ui/icons/ArrowRight"));
var styles_1 = require("@material-ui/core/styles");
var useStyles = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        expand: {
            position: 'absolute',
            marginLeft: '190px',
        },
        item: {
            maxWidth: '150px',
        },
    });
});
function MenuItemCollapse(props) {
    var _a = (0, react_1.useState)(false), open = _a[0], setOpen = _a[1];
    var classes = useStyles({});
    return (React.createElement("div", null,
        React.createElement(ListItem_1.default, { button: true, onClick: function () { return setOpen(!open); } },
            React.createElement(ListItemIcon_1.default, null, props.icon || React.createElement(ArrowRight_1.default, null)),
            React.createElement("div", { className: classes.item },
                React.createElement(core_1.Typography, { variant: "inherit", noWrap: true, style: { fontFamily: 'Lato' } }, props.primary)),
            React.createElement("div", { className: classes.expand }, open ? React.createElement(ExpandLess_1.default, null) : React.createElement(ExpandMore_1.default, null))),
        React.createElement(Collapse_1.default, { in: open, timeout: "auto", unmountOnExit: true },
            React.createElement(List_1.default, { component: "div", disablePadding: true }, props.children))));
}
exports.default = MenuItemCollapse;
//# sourceMappingURL=MenuItemCollapse.js.map